<template lang="html">
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
</style>
